import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal',
  standalone: true,
})
export class TimezonePipe implements PipeTransform {
  transform(utcDateStr: string, ...args: unknown[]) {
    if (!utcDateStr) {
      return '';
    }

    const utcDate = new Date(utcDateStr);
    const timezoneOffset = new Date().getTimezoneOffset();
    return new Date(utcDate.getTime() - timezoneOffset * 60 * 1000);
  }
}
